// import React from "react";

export const Script = {

    url: (url: any) => {

        return new Promise((resolve, reject) => {
            let scriptRemove = document.getElementById(url.id);
            scriptRemove?.remove();
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = url.src;
            script.id = url.id;
            script.async = false;
            script.addEventListener('load', () => resolve(script), false);
            script.addEventListener('error', () => reject(script), false);
            document.body.appendChild(script);
        });
    },
    urls: (urls: any) => {

        return Promise.all(
            urls.map(Script.url)
        );
    }
};

// export const Script = (urls: any) => (
//     <script src={urls.scr}></script>
// );